var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"specialOffer-view"},[_c('h1',{staticClass:"specialOffer-view-header",class:{
      'text-h1': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-h2T': _vm.$mq === 'm',
      'text-h3': _vm.$mq === 's'
    }},[_vm._v("\n    Прайс-лист\n  ")]),_c('p',{staticClass:"specialOffer-view-desc",class:{
      'text-body2': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-body5': _vm.$mq === 'm',
      'text-body6': _vm.$mq === 's'
    }},[_vm._v("\n    Эксклюзивные цены на запасные части Gilbarco Veeder-Root\n    со склада в Москве от поставщика ПАО \"ЛУКОЙЛ\". Для\n    оптовых клиентов мы предоставляем особые скидки.\n  ")]),_c('Table',{attrs:{"table":_vm.gilbarcoProducts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }